import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LocalStorageEnum, StorageService } from '@olymp/shared';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({
  name: 'languagePipe',
  standalone: true,
})
export class LanguagePipe implements PipeTransform {
  private $storageService = inject(StorageService);
  private $translocoService = inject(TranslocoService);

  transform(value: any, translateLang?: string): Observable<string> {
    if (!value && !this.$storageService.get(LocalStorageEnum.Language)) {
      return of(value);
    }

    return this.$translocoService.langChanges$.pipe(
      switchMap((lang) => {
        if (translateLang) {
          return of(value[translateLang]);
        }
        return of(value[lang] || value['en']);
      }),
    );
  }
}
